module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Pictures1-881e83a2aacf01ba3f95c9010734a51a.svg";